import { ChangeDetectorRef, SimpleChanges } from '@angular/core';
import cloneDeep from 'lodash.clonedeep';
import { FORMAT_DEFAULT, FUND_CHART_SYSTEM_DEFAULT_STATE } from 'ChartApp/ts/features/fundamental-chart/constants';
import { ChartZoomService } from 'ChartApp/ts/features/charts-shared/services/chart-zoom.service';
import { FundChartService } from 'ChartApp/ts/services/fund-chart.service';
import * as i0 from "@angular/core";
import * as i1 from "ChartApp/ts/services/fund-chart.service";
import * as i2 from "@angular/common";
import * as i3 from "../fundamental-chart/components/fundamental-chart/fundamental-chart.component";
import * as i4 from "../fundamental-chart/components/fund-chart-date-zoom/fund-chart-date-zoom.component";
const _c0 = () => ({ list: "chart-control-compact" });
function SimpleFundChartComponent_ycn_fund_chart_date_zoom_6_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-fund-chart-date-zoom", 8);
    i0.ɵɵlistener("selectZoomOptionHandler", function SimpleFundChartComponent_ycn_fund_chart_date_zoom_6_Template_ycn_fund_chart_date_zoom_selectZoomOptionHandler_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setZoomValue($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("zoom", ctx_r1.currentZoom)("customCssClasses", i0.ɵɵpureFunction0(2, _c0));
} }
export class SimpleFundChartComponent {
    constructor(changeDetector, fundChartService) {
        this.changeDetector = changeDetector;
        this.fundChartService = fundChartService;
        this.securityIds = [];
        this.calcs = [];
        this.format = FORMAT_DEFAULT;
        this.zoom = '';
        this.showRecessions = false;
        this.initialChartState = null;
        this.configurableOptions = {
            dynamicHeight: false,
            showLatestValueLabels: true,
            tooltipStyle: 'box',
            yAxisWidth: 60,
            tooltipCallback: (data) => data,
        };
        this.chartOptions = {
            xAxis: {
                tickAmount: 4,
            },
        };
        this.loadingChart = true;
        this.noDataClass = 'get-started-border';
        this.chartDataUrl = '';
        this.currentZoom = '';
        this.tooltipData = [];
        this.subchartOffsets = [];
        this.state = cloneDeep(FUND_CHART_SYSTEM_DEFAULT_STATE);
    }
    ngOnInit() {
        if (this.initialChartState) {
            // Use full state that was passed
            this.state = cloneDeep(this.initialChartState);
        }
        else {
            // Construct state from default state plus inputs
            const calcs = [];
            const securities = [];
            for (let i = 0; i < this.calcs.length; i += 1) {
                calcs.push({
                    id: this.calcs[i],
                    include: true,
                });
            }
            for (let i = 0; i < this.securityIds.length; i += 1) {
                securities.push({
                    id: this.securityIds[i],
                    include: true,
                });
            }
            this.state.calcs = calcs;
            this.state.format = this.format;
            this.state.securities = securities;
            this.state.zoom = this.zoom || FUND_CHART_SYSTEM_DEFAULT_STATE.zoom;
        }
        this.setChartDataUrls();
    }
    ngOnChanges(changes) {
        if (changes.showRecessions) {
            this.state.recessions = this.showRecessions;
            this.configurableOptions.recessions = this.showRecessions;
            this.setChartDataUrls();
        }
    }
    setChartDataUrls() {
        this.currentZoom = this.state.zoom;
        this.chartDataUrl = this.fundChartService.getChartDataUrl(this.state);
    }
    getQueryParams() {
        return this.fundChartService.getChartDataUrlQuery(this.state);
    }
    setZoomValue(zoomOption) {
        this.state.zoom = zoomOption.value;
        this.setChartDataUrls();
    }
    chartDataHandler(chartData) {
        this.loadingChart = !(chartData && Array.isArray(chartData.chart_data) && chartData.chart_data.length > 0);
        // Manually detect changes here
        this.changeDetector.detectChanges();
    }
    subchartOffsetsHandler(subchartOffsets) {
        this.subchartOffsets = subchartOffsets;
    }
    tooltipDataHandler(tooltipData) {
        this.tooltipData = tooltipData;
    }
}
SimpleFundChartComponent.ɵfac = function SimpleFundChartComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SimpleFundChartComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.FundChartService)); };
SimpleFundChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SimpleFundChartComponent, selectors: [["ycn-simple-fund-chart"]], inputs: { securityIds: "securityIds", calcs: "calcs", format: "format", zoom: "zoom", showRecessions: "showRecessions", initialChartState: "initialChartState" }, standalone: false, features: [i0.ɵɵProvidersFeature([ChartZoomService]), i0.ɵɵNgOnChangesFeature], decls: 8, vars: 5, consts: [[1, "chart-cover"], [1, "chart-interactive"], [1, "chart-item"], [1, "chart-options"], [1, "chart-wrap"], [1, "chart-canvas"], [3, "zoom", "customCssClasses", "selectZoomOptionHandler", 4, "ngIf"], [1, "chart-canvas", "d-flex", "flex-column", 3, "chartDataHandler", "subchartOffsetsHandler", "tooltipDataHandler", "configurableOptions", "chartOptions", "chartDataUrl", "noDataClass"], [3, "selectZoomOptionHandler", "zoom", "customCssClasses"]], template: function SimpleFundChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
        i0.ɵɵelement(3, "div", 3);
        i0.ɵɵelementStart(4, "div", 4)(5, "div", 5);
        i0.ɵɵtemplate(6, SimpleFundChartComponent_ycn_fund_chart_date_zoom_6_Template, 1, 3, "ycn-fund-chart-date-zoom", 6);
        i0.ɵɵelementStart(7, "ycn-fundamental-chart", 7);
        i0.ɵɵlistener("chartDataHandler", function SimpleFundChartComponent_Template_ycn_fundamental_chart_chartDataHandler_7_listener($event) { return ctx.chartDataHandler($event); })("subchartOffsetsHandler", function SimpleFundChartComponent_Template_ycn_fundamental_chart_subchartOffsetsHandler_7_listener($event) { return ctx.subchartOffsetsHandler($event); })("tooltipDataHandler", function SimpleFundChartComponent_Template_ycn_fundamental_chart_tooltipDataHandler_7_listener($event) { return ctx.tooltipDataHandler($event); });
        i0.ɵɵelementEnd()()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", !ctx.loadingChart);
        i0.ɵɵadvance();
        i0.ɵɵproperty("configurableOptions", ctx.configurableOptions)("chartOptions", ctx.chartOptions)("chartDataUrl", ctx.chartDataUrl)("noDataClass", ctx.noDataClass);
    } }, dependencies: [i2.NgIf, i3.FundamentalChartComponent, i4.FundChartDateZoomComponent], encapsulation: 2 });
